import { ListFilterState } from 'src/app/shared/components/list-filter-toolbar/list-filter-toolbar.component';

export function applyListFilter<T>(
  items: T[],
  state: ListFilterState,
  currentUserId: string | null,
  accessors: {
    name: (item: T) => string;
    createdByUserId: (item: T) => string | null | undefined;
    isExempt?: (item: T) => boolean;
  }
): T[] {
  const query = state.search.trim().toLowerCase();
  return items.filter(item => {
    const exempt = accessors.isExempt?.(item) ?? false;
    const matchesOwner = exempt || !state.hideShared || accessors.createdByUserId(item) === currentUserId;
    const matchesSearch = !query || accessors.name(item).toLowerCase().includes(query);
    return matchesOwner && matchesSearch;
  });
}
